export * from './info.page'
